import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../../style/custom/user-detail.scss";
import TextField from "../../components/bootstrap/input-alt";
import Form from "formsy-react";
import { getFormData, setFormData } from "../../components/manager/form";
import Footer from "../../components/section/footer";
import UserFormPanel from "../../components/section/user-form-panel";
import SelectField from "../../components/bootstrap/select-field";
import { useMutation, useQuery } from "@apollo/client";
import StandardTerms from "../../components/standard-terms";
import PrivacyPolicy from "../../components/portal/privacy-policy";
import {
  getCountriesQuery,
  getCountriesResult,
} from "../../components/logic/address";
import Captcha from "../../components/bootstrap/captcha2";
import {
  createMobileVerificationMutation,
  resendVerificationMutation,
  validateMobileVerificationMutation,
} from "../../components/logic/mobile";
import { Modal, ModalBody, ModalFooter, ModalTitle } from "react-bootstrap";
import DataHelper from "../../utils/dataHelper";

function MobileValidationForm(props) {
  const { show, handleClose } = props;
 
  const data = getFormData();
  const { mobileNumber } = data;

  const [error, setError] = useState(null);
  const [seconds, setSeconds] = useState(30);
  const [processing, setProcessing] = useState(false);
  const [valid, setValid] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");

  const history = useHistory();
  function handleValid() {
    setValid(true);
  }

  function handleInvalid() {
    setValid(false);
  }
  function handleTimer() {
    const itval = setInterval(() => {
      const s = seconds - 1;
      if (seconds < 1) {
        clearInterval(itval);
        setSeconds(0);
        setInterval(null);
      } else {
        setSeconds(s);
      }
    }, 1000);
  }
  const [resendMutation] = useMutation(resendVerificationMutation);
  const [validateMutation] = useMutation(validateMobileVerificationMutation);

  async function handleOnSubmit(values) {
    setProcessing(true);
    setFormData(values);
    const data = getFormData();
    const { mobileNumber } = data;
    const response = await validateMutation({
      variables: { mobileNumber, code: data.verification },
    });
    // console.log("response", { response, data });
    if (
      response?.data?.classMethods?.MobileVerification
        ?.validateMobileVerification
    ) {
      history.push("/review");
    } else {
      setProcessing(false);
      setError("Invalid Verification Code");
    }
    // return refs.form.updateInputsWithError({
    //   verification: "Invalid verification code",
    // });
  }

  async function handleOnInvalidSubmit() {
    if (seconds === 0) {
      await setProcessing(true);
      const data = getFormData();
      const { mobileCountry, mobileNumber } = data;
      const response = await resendMutation({
        variables: { mobileCountry, mobileNumber },
      });
      if (response.data.resendVerification) {
        setProcessing(false);
        setSeconds(30);
        return handleTimer();
      }
    }
    return undefined;
  }

  const { formatMessage } = useIntl();
  return (
    <Modal show={show}>
      <Form
        className="section"
        onValidSubmit={handleOnSubmit}
        onInvalidSubmit={handleOnInvalidSubmit}
        noValidate
        onValid={handleValid}
        onInvalid={handleInvalid}
      >
        <ModalTitle>
          <FormattedMessage
            id="register.userDetails.verification.title"
            values={{
              // dialCode: selectedCountry.dialCode,
              mobileNo: DataHelper.cleanMobile(mobileNumber),
            }}
          />
        </ModalTitle>
        <ModalBody>
          <Container fluid className="no-gutters">
            {error && <Row>
              <Col xs={"auto"} className="mx-auto">
                <div className="alert alert-danger my-1">
                  {error}
                </div>
              </Col>
            </Row>}
            <Row>
              <Col xs={12}>
                <TextField
                  className="vw-form-field  center-placeholder"
                  inputStyle={{ width: "100%" }}
                  // onChange={handleOnTextChange}
                  required
                  placeholder={formatMessage({
                    id: "placeholders.mobileNumberVerification",
                  })}
                  validations={{
                    maxLength: 15,
                    isExisty: true,
                  }}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  autoComplete="off"
                  validationErrors={{
                    isExisty: (
                      <FormattedMessage id="validation.errors.required.mobileNumberVerification" />
                    ),
                    maxLength: (
                      <FormattedMessage id="validation.errors.maxLength50" />
                    ),
                  }}
                  name="verification"
                  // disabled={processing}
                  // defaultValue={data.verification}
                />
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Container fluid>
            <Row>
              <Col xs={"auto"} className="ml-auto">
                <button className="vw-button orange" onClick={handleClose}>
                  <FormattedMessage id="register.userDetails.close" />
                </button>
              </Col>
              <Col xs={"auto"} className="">
                <div className={"submit single"}>
                  <input
                    type="submit"
                    className="vw-button orange next-btn"
                    value={formatMessage({
                      id:
                        seconds === 0 && (verificationCode || "").length === 0
                          ? "register.userDetails.buttonResend"
                          : "register.userDetails.buttonConfirm",
                    })}
                    disabled={(!valid && seconds > 0) || processing}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </ModalFooter>
      </Form>
    </Modal>
  );
}

export default function UserDetails() {
  const data =
    getFormData();
  const { firstName, lastName, homeAddress, shippingAddress, hardware, mobileNumber } = data;
  const [captchaKey, setCaptchaKey] = useState(new Date().getTime());
  const [processing, setProcessing] = useState(false);
  const { formatMessage } = useIntl();
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);
  const [createMobileVerification] = useMutation(
    createMobileVerificationMutation
  );
  const [showMobileVerificationForm, setShowMobileVerificationForm] =
    useState(false);
  async function handleOnSubmit(data) {
    setFormData(data);
    setProcessing(true);
    const response = await createMobileVerification({
      variables: {
        mobileNumber: data.mobileNumber,
        captcha: data.captcha,
        captchaKey: data.captchaKey,
      },
    });
    if (
      response?.data?.classMethods?.MobileVerification?.createMobileVerification
    ) {
      setShowMobileVerificationForm(true);
    }
    setProcessing(false);
  }
  function handleCloseMobileVerificationForm() {
    setCaptchaKey(new Date().getTime());
    setShowMobileVerificationForm(false);
  }
  const countryQuery = useQuery(getCountriesQuery);
  if (countryQuery.loading) {
    return <React.Fragment />;
  }

  const countries = getCountriesResult(countryQuery);
  // console.log("countries", {countryQuery, countries});
  const defaultCountry = homeAddress?.countryId
    ? homeAddress?.countryId
    : (countries || []).reduce((prev, value) => {
      return value && value.name === "Australia" ? value.id : prev;
    }, {});
  // const data = getFormData();
  console.log("homeAddress", { data, showMobileVerificationForm });
  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="user-detail-form-container">
        <div className="user-detail-inner">
          <div className="section-1">
            <Row className="vw-fs">
              <Col lg={12} className="vw-fs-section">
                <UserFormPanel
                  showMobileVerificationForm={showMobileVerificationForm}
                  handleCloseMobileVerificationForm={handleCloseMobileVerificationForm}
                  handleOnSubmit={handleOnSubmit}
                  countries={countries}
                  captchaKey={captchaKey}
                  processing={processing}
                />
              </Col>
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy}/>
        </div>
      </div>
    </>
  );
}